import { jsx } from 'react/jsx-runtime';

/** ![listOrderedIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNMTAgNmgxMU0xMCAxMmgxMU0xMCAxOGgxMU00IDZoMXY0TTQgMTBoMk02IDE4SDRjMC0xIDItMiAyLTNzLTEtMS41LTItMSIvPjwvc3ZnPg==) */
const listOrderedIcon = /*#__PURE__*/jsx("path", {
  d: "M10 6h11M10 12h11M10 18h11M4 6h1v4M4 10h2M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"
});

export { listOrderedIcon };
